import { createApp } from 'vue'
// import App from './06_other_component/04/App.vue'
import App from './00/App.vue'
import registerDirectives from './06_other_component/04/directives'

const app = createApp(App)
registerDirectives(app)
app.mount('#app')
